import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LiveClassEvent } from './live-class-event';
import { LiveClassEventDto } from './live-class-event-dto';

@Injectable()
export class LiveClassEventService {
  public onChange: BehaviorSubject<LiveClassEventDto> = new BehaviorSubject(null);

  constructor() {}

  triggerEvent(event: LiveClassEvent, data: number | null): void {
    this.onChange.next({
      event,
      data,
    });
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-event.service.ts